// extracted by mini-css-extract-plugin
module.exports = {"container":"bW","logo":"bX","mainPanel":"bY","noActions":"bZ","noOneLeftAction":"b0","noRightAction":"b1","onlyOneLeftAction":"b2"};